var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"fileInputImport",attrs:{"type":"file","name":"fileInputImport","accept":".csv"},on:{"change":_vm.selectFile}}),_c('span',{on:{"click":function($event){return _vm.openFileExplorer()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }